import {SODeleteRelationshipAttributePermission} from '../../core/relationship-attribute-permission/so-delete-relationship-attribute-permission';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRelationshipAttributePermission extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRelationshipAttributePermission;
}